<template>
  <div class="locked-content-header"><LockIcon size="14" /> Locked content</div>
</template>

<script>
import LockIcon from '@/assets/icons/fill/lock.svg'

export default {
  name: 'LockedContentHeader',
  components: {
    LockIcon: { ...LockIcon, name: 'LockIcon' },
  },
}
</script>

<style lang="scss" scoped>
.locked-content-header {
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1;
  background: var(--paypal-gradient);
  padding: 0 10px;
  font-size: 12px;
  svg {
    width: 14px;
    fill: var(--white);
  }
}
</style>
